import * as v2 from '../v2/constants';
import * as v1 from '../constants';

import type {
  TDraftAssessmentSection,
  TPersistedAssessmentItem,
} from '../types';

import DraftAssessment from './DraftAssessment';

class PersistedAssessment {
  draft: DraftAssessment;

  constructor({ draft }: { draft: DraftAssessment }) {
    this.draft = draft;
  }

  toDraftAssessmentSection(
    persistedItem: TPersistedAssessmentItem,
  ): TDraftAssessmentSection {
    const sectionId = persistedItem.itemType as v2.SECTION;

    const section = this.draft.createSection(sectionId);

    persistedItem.assessmentQA?.forEach((qaItem) => {
      section.items[qaItem.question].value = qaItem.answer;

      const sectionItems = this.draft.sectionItems[section.id as v2.SECTION];
      const item = sectionItems?.find((i) => i.question === qaItem.question);

      if (item?.comment) {
        const commentId = item.comment.id;

        section.items[commentId].value = qaItem.comment;
      }
    });

    return section;
  }

  static attachV2Properties(
    item: TPersistedAssessmentItem,
  ): TPersistedAssessmentItem {
    const newItem: TPersistedAssessmentItem = JSON.parse(JSON.stringify(item));

    const assessmentQA: TPersistedAssessmentItem['assessmentQA'] = [];

    if (item.itemFunctional?.isFunctional) {
      assessmentQA.push({
        question: v1.isWorkingId(item.itemType) as any,
        answer: item.itemFunctional.isFunctional as any,
        comment: item.itemFunctional?.comment ?? '',
      });
    }

    if (item.itemStatus?.conservation) {
      assessmentQA.push({
        question: v1.conservationId(item.itemType) as any,
        answer: item.itemStatus.conservation,
      });
    }

    return { ...newItem, assessmentQA };
  }
}

export default PersistedAssessment;
